import { Dispatch } from 'redux';
import { ILLMProfile, ILLMProfileFields } from './types';
import { WsCommandSubject } from '../crud/types';
import { prepareCreateCommandAction, prepareReadCommandAction, prepareUpdateCommandAction, prepareDeleteCommandAction } from '../crud/actions';
import {
  ADD_LLM_PROFILE,
  SET_LLM_PROFILES,
  SET_CURRENT_LLM_PROFILE,
  SET_LLM_PROFILE_CONFIRMED_BY_BACKEND,
  SET_LLM_PROFILE_STATE,
  DELETE_LLM_PROFILE,
  TOGGLE_LLM_PROFILE_FORM,
  UPDATE_LLM_PROFILE_FIELD,
  SET_LLM_PROFILE_FORM_ERRORS,
  RESET_LLM_PROFILE_FORM,
  ICreateLLMProfileParams,
  IAddLLMProfileAction,
  ISetLLMProfilesAction,
  ISetCurrentLLMProfileAction,
  ISetLLMProfileConfirmedByBackendAction,
  ISetLLMProfileStateAction,
  IDeleteLLMProfileAction,
  IToggleLLMProfileFormAction,
  IUpdateLLMProfileFieldAction,
  ISetLLMProfileFormErrorsAction,
  IResetLLMProfileFormAction,
} from './types';

// LLMProfile-specific action creators
export const prepareCreateLLMProfileCommandAction = (profile_id: string, fields: ILLMProfileFields) =>
  prepareCreateCommandAction({
    type: 'llmProfiles' as WsCommandSubject,
    params: {
      profile_id,
      ...fields,
    } as ICreateLLMProfileParams,
  });

export const addLLMProfileAction = (llmProfile: ILLMProfile): IAddLLMProfileAction => ({
  type: ADD_LLM_PROFILE,
  payload: llmProfile,
});

export const prepareReadLLMProfilesCommandAction = () =>
  prepareReadCommandAction({
    type: 'llmProfiles' as WsCommandSubject,
    params: {},
  });

export const setLLMProfilesAction = (llmProfiles: ILLMProfile[]): ISetLLMProfilesAction => ({
  type: SET_LLM_PROFILES,
  payload: llmProfiles,
});

export const setCurrentLLMProfileAction = (profile_id: string) => (dispatch: Dispatch) => {
  const action: ISetCurrentLLMProfileAction = {
    type: SET_CURRENT_LLM_PROFILE,
    payload: profile_id,
  };
  dispatch(action);
};

export const setLLMProfileConfirmedByBackendAction = (profile_id: string, updated_at: string): ISetLLMProfileConfirmedByBackendAction => ({
  type: SET_LLM_PROFILE_CONFIRMED_BY_BACKEND,
  profile_id,
  updated_at,
});

export const prepareUpdateLLMProfileCommandAction = (profile_id: string, updates: Partial<ILLMProfile>) =>
  prepareUpdateCommandAction({
    type: 'llmProfiles' as WsCommandSubject,
    params: {
      profile_id: profile_id,
      ...updates,
    },
  });

export const setLLMProfileStateAction = (update: Partial<ILLMProfile> & { profile_id: string }): ISetLLMProfileStateAction => ({
  type: SET_LLM_PROFILE_STATE,
  payload: update,
});

export const prepareDeleteLLMProfileCommandAction = (profile_id: string) =>
  prepareDeleteCommandAction({
    type: 'llmProfiles' as WsCommandSubject,
    params: { profile_id: profile_id },
  });

export const deleteLLMProfileAction = (profile_id: string): IDeleteLLMProfileAction => ({
  type: DELETE_LLM_PROFILE,
  payload: profile_id,
});

// Form management action creators
export const toggleLLMProfileFormAction = (show: boolean): IToggleLLMProfileFormAction => ({
  type: TOGGLE_LLM_PROFILE_FORM,
  payload: show,
});

export const updateLLMProfileFieldAction = (field: string, value: string | number | boolean): IUpdateLLMProfileFieldAction => ({
  type: UPDATE_LLM_PROFILE_FIELD,
  payload: { field, value },
});

export const setLLMProfileFormErrorsAction = (errors: Record<string, string>): ISetLLMProfileFormErrorsAction => ({
  type: SET_LLM_PROFILE_FORM_ERRORS,
  payload: errors,
});

export const resetLLMProfileFormAction = (): IResetLLMProfileFormAction => ({
  type: RESET_LLM_PROFILE_FORM,
});
